import { render, staticRenderFns } from "./m-paiban-task-progress-cell.vue?vue&type=template&id=0e63eeb7&"
import script from "./m-paiban-task-progress-cell.vue?vue&type=script&lang=ts&setup=true&"
export * from "./m-paiban-task-progress-cell.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports